// extracted by mini-css-extract-plugin
module.exports = {"secondHandTag":"c5lZhgQ","small":"zIOg8G"};